import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-message"
}

import { useField, useFieldArray } from 'vee-validate';
import Search from './components/Search.vue';
import MedicationItem from './components/MedicationItem.vue';


export default {
  __name: 'MedicationChoose',
  setup(__props) {

const { errors, errorMessage } = useField('selectedMedications');

const { remove, fields, push } = useFieldArray('selectedMedications');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Search, {
      onAddItem: _unref(push),
      hasErrors: !!_unref(errors).length,
      selectedMedications: _unref(fields)
    }, null, 8, ["onAddItem", "hasErrors", "selectedMedications"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, idx) => {
      return (_openBlock(), _createBlock(MedicationItem, {
        id: idx,
        field: field.value,
        key: field.key,
        onRemoveItem: _unref(remove)
      }, null, 8, ["id", "field", "onRemoveItem"]))
    }), 128)),
    (_unref(errorMessage))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

}